// extracted by mini-css-extract-plugin
export default {"title":"working_title__DtbQu"};